import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-191333f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-1 w-full",
  "data-cy": "pdf-MSE-table"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-left pl-2 align-text-top" }
const _hoisted_4 = {
  key: 0,
  class: "text-left value-col text-center align-text-top"
}
const _hoisted_5 = { class: "numberCol align-text-top" }
const _hoisted_6 = { class: "chipCol align-text-top" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "chipCol align-text-top" }
const _hoisted_10 = { class: "chipCol align-text-top" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "text-xxs"
}
const _hoisted_13 = { class: "chipCol w-1/6 align-text-top" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "text-xxs"
}
const _hoisted_16 = { class: "text-left pl-2 numberCol w-1/5" }
const _hoisted_17 = { class: "overflow-ellipsis" }
const _hoisted_18 = {
  key: 0,
  class: "text-left value-col text-center",
  "data-cy": "tableofcontent-page"
}
const _hoisted_19 = {
  class: "numberCol text-center numberCol w-1/12",
  "data-cy": "mangeldata"
}
const _hoisted_20 = {
  key: 1,
  class: "text-center numberCol chip-td w-1/6"
}
const _hoisted_21 = { class: "text-center numberCol chip-td w-1/6" }
const _hoisted_22 = { class: "text-center numberCol chip-td w-1/6" }
const _hoisted_23 = { class: "text-center numberCol chip-td w-1/6" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { colspan: "4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PdfChip = _resolveComponent("PdfChip")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    (_ctx.showTitle)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.positionTranslated), 1),
          (_ctx.valueTitle !== undefined && _ctx.hasDescription1Enabled)
            ? (_openBlock(), _createElementBlock("th", _hoisted_4, _toDisplayString(_ctx.valueTitle), 1))
            : _createCommentVNode("", true),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.hideMangelAnzahl
            ? ""
            : _ctx.t("hzba.pdf.mangelAnzahl", 1, { locale: _ctx.lang })), 1),
          _createElementVNode("th", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.t("hzba.pdf.maluswert", 1, { locale: _ctx.lang })) + " ", 1),
            _hoisted_7,
            (!_ctx.shortTitle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.t("hzba.pdf.gesamt", 1, { locale: _ctx.lang })), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.t("hzba.pdf.hinweis", 1, { locale: _ctx.lang })), 1),
          _createElementVNode("th", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.t("hzba.pdf.safety", 1, { locale: _ctx.lang })) + " ", 1),
            _hoisted_11,
            (!_ctx.shortTitle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.t("hzba.pdf.akuteMassnahmeNotwendig", 1, { locale: _ctx.lang })), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("th", _hoisted_13, [
            _createTextVNode(_toDisplayString(_ctx.t("hzba.pdf.effizienz", 1, { locale: _ctx.lang })) + " ", 1),
            _hoisted_14,
            (!_ctx.shortTitle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.t("hzba.pdf.zeitlichPlanbareMassnahmeNotwendig", 1, {
              locale: _ctx.lang,
            })), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxShownItems
        ? _ctx.data.slice(0, _ctx.maxShownItems)
        : _ctx.data, (entry, key) => {
      return (_openBlock(), _createElementBlock("tr", {
        key: key,
        class: "data-tr items-center",
        "data-cy": "MSE-table-data-row"
      }, [
        _createElementVNode("td", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(entry.title), 1)
        ]),
        (_ctx.hasDescription1Enabled)
          ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
              _createElementVNode("span", null, _toDisplayString(entry.description1), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.hideMangelAnzahl ? "1" : entry.description2), 1),
        (entry.malus)
          ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
              _createVNode(_component_PdfChip, {
                value: entry.malus?.value,
                color: entry.malus?.color,
                "pdf-mode": ""
              }, null, 8, ["value", "color"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("td", _hoisted_21, [
          (entry?.hinweis)
            ? (_openBlock(), _createBlock(_component_PdfChip, {
                key: 0,
                value: entry.hinweis.value,
                color: entry.hinweis.color,
                "pdf-mode": ""
              }, null, 8, ["value", "color"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_22, [
          (entry?.safety)
            ? (_openBlock(), _createBlock(_component_PdfChip, {
                key: 0,
                value: entry.safety.value,
                color: entry.safety.color,
                "pdf-mode": ""
              }, null, 8, ["value", "color"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_23, [
          (entry.efficiency)
            ? (_openBlock(), _createBlock(_component_PdfChip, {
                key: 0,
                value: entry.efficiency.value,
                color: entry.efficiency.color,
                "pdf-mode": ""
              }, null, 8, ["value", "color"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    (_ctx.maxShownItems && (_ctx.data.length > _ctx.maxShownItems))
      ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
          _createElementVNode("td", _hoisted_25, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}